import { render, staticRenderFns } from "./menu-component.vue?vue&type=template&id=593317e6&scoped=true&"
import script from "./menu-component.vue?vue&type=script&lang=js&"
export * from "./menu-component.vue?vue&type=script&lang=js&"
import style0 from "./menu-component.vue?vue&type=style&index=0&id=593317e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593317e6",
  null
  
)

export default component.exports